import React, { useState } from "react"
import { parseBlockContent } from "helpers/parseBlockContent"
import { Grid, Row, Col } from "UI/Grid"
import { ReactComponent as DownloadIcon } from "icons/download-icon.svg"
import { Content } from "UI/Content"
import { Categories } from "../../Project/Categories"
import { Breadcrumbs } from "../../UI/Breadcrumbs"
import { SearchResults } from "../../Project/SearchResults"
import { CaseStudy } from "../../Project/CaseStudy"
import AvenueLink from "UI/AvenueLink"
import { Document, Page } from "react-pdf"
import PDFViewer from "pdf-viewer-reactjs"
import { useStaticQuery, graphql } from "gatsby"
import { LocationModule } from "../../Project/LocationModule"

import {
  InternalTemplateContainer,
  InternalRHSMenu,
  PageTitle,
  PageDetails,
  Footnotes,
  LeftCol,
  PDFWrap,
} from "./style"

const InternalTemplate = ({
  pageData,
  relatedResources,
  variation,
  caseStudy,
}) => {
  const {
    title,
    content,
    publicLibrary,
    categories,
    relatedCaseStudy,
  } = pageData
  const parsedContent = content ? parseBlockContent(content) : null

  console.log("yolo", publicLibrary)

  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  const staticQuery = useStaticQuery(
    graphql`
      query {
        latestPosts: allWpPost(limit: 6) {
          nodes {
            title
            link
            uri
          }
        }

        latestCS: allWpCaseStudy(limit: 6) {
          nodes {
            title
            link
            uri
          }
        }
      }
    `
  )

  return (
    <InternalTemplateContainer variation={variation}>
      <Grid>
        <Row>
          <LeftCol xs={12} md={9}>
            <Categories categories={categories} />
            <PageTitle dangerouslySetInnerHTML={{ __html: title }} />

            <PageDetails>
              {publicLibrary?.pbAuthor?.type === "External" && publicLibrary?.pbAuthor?.externalAuthors?.map(
                (author, index) => {
                  const firstName = author.firstName || ""
                  return (
                    <span className="name">
                      {`${author?.lastName?.toUpperCase()}${
                        author.firstName ? `, ${firstName}` : ""
                      }${
                      index !==
                      publicLibrary.pbAuthor.externalAuthors.length - 1
                        ? ", "
                        : ""
                    }`}
                    </span>
                  )
                }
              )}
              
              {publicLibrary?.pbAuthor?.type !== "External" && <span className="name">WORKPLACE GIVING AUSTRALIA</span> }


              <span className="author" />

              {publicLibrary?.pbCity && (
                <>
                  <span
                    dangerouslySetInnerHTML={{ __html: publicLibrary?.pbCity }}
                  />
                  {","}
                </>
              )}
              {publicLibrary?.pbCountry && (
                <>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: publicLibrary?.pbCountry,
                    }}
                  />
                  {"."}
                </>
              )}
              {publicLibrary?.publisherName && (
                <>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: publicLibrary?.publisherName,
                    }}
                  />
                  {"."}
                </>
              )}
              {publicLibrary?.pbYear && (
                <>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: publicLibrary?.pbYear,
                    }}
                  />
                  {"."}
                </>
              )}
              {publicLibrary?.pbType && (
                <>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: publicLibrary?.pbType,
                    }}
                  />
                </>
              )}
              {publicLibrary?.pbLocation && (
                <>
                  {" "}
                  <span>(Location: {publicLibrary?.pbLocation})</span>
                </>
              )}
            </PageDetails>
            <Content>{parsedContent}</Content>
            <Footnotes>
              {/* <h3>Footnotes</h3>
              <ol>
                <li>
                  Why Workplace Giving. PIPER, John. Sydney, Australia. Allen &
                  Unwin. 2016.
                </li>

                <li>
                  A number of additional resources can be found at
                  www.1mdonors.org.au
                </li>
              </ol> */}

              {/* <AvenueImg /> */}
              {typeof window !== 'undefined' && publicLibrary?.pbPdf ? (
                <>
                  <PDFWrap>
                    <Document
                      width="100%"
                      file={publicLibrary.pbPdf}
                      onLoadSuccess={onDocumentLoadSuccess}
                    >
                      <Page pageNumber={pageNumber} />
                    </Document>
                  </PDFWrap>
                  {/* <button onClick={() => setPageNumber(pageNumber + 1)}>
                    Next page
                  </button>
                  <p>
                    Page {pageNumber} of {numPages}
                  </p> */}
                  {/* <PDFViewer
                    document={{
                      url: publicLibrary.pbPdf,
                    }}
                    // hideNavbar
                    hideZoom
                    hideRotation
                    css="pdfPreview"
                    canvasCss="pdfPreview"
                  /> */}
                  <AvenueLink className="downloadLink" to={publicLibrary.pbPdf}>
                    <DownloadIcon />
                    Download (PDF)
                  </AvenueLink>
                </>
              ) : null}
            </Footnotes>
          </LeftCol>
          <Col xs={12} md={3}>
            {caseStudy && <CaseStudy caseStudy={pageData} />}
            <InternalRHSMenu>
              {caseStudy && (
                <div>
                  {relatedCaseStudy?.relatedCaseStudy
                    ? "Related Case Studies"
                    : "Recently Added Case Studies"}
                </div>
              )}

              {!caseStudy && (
                <div>
                  {relatedResources
                    ? "Related Resources"
                    : "Recently Added Resources"}
                </div>
              )}
            </InternalRHSMenu>
            <SearchResults
              internal
              data={
                caseStudy
                  ? relatedCaseStudy?.relatedCaseStudy ||
                    staticQuery?.latestCS?.nodes
                  : relatedResources || staticQuery?.latestPosts?.nodes
              }
            />
          </Col>
        </Row>
      </Grid>
    </InternalTemplateContainer>
  )
}

export default InternalTemplate
